import type { BackendRouteDefinition } from '../types';

// PRA-826 — Records a manually-signed engagement letter (a firm employee
// uploaded a physically-signed PDF on the client's behalf). Distinct from
// `saveEngagementLetterSignature` because it is firm-side authenticated
// (standard ID-token + App Check) and skips the expiration check that
// gates the digital signature portal — the ticket explicitly requires the
// manual path to keep working after a letter has expired.
export const saveManualEngagementLetterSignatureRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/engagement-letters:save-manual-signature',
} as const satisfies BackendRouteDefinition;
